import {
    GxReservationDigitalKeyStatusResponse,
    GxReservationDigitalKeyStatusResult,
    GxVirtualKeyCardInReservation,
} from '@mews-commander/data-access';
import { useCommanderSelector } from '@mews-commander/utils';
import { getReservationIdsByGroupId } from '@mews-commander/legacy-entities/src/ducks';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { createWeakMapSelector } from '@mews/framework';
import { keyBy } from '@mews/fp';
import { useDigitalKeyReservationStatusQuery } from '../queries/useDigitalKeyReservationStatusQuery';

export const useSmartDetailIsDigitalKeyStatus = (reservationId?: string) => {
    const { data } = useDigitalKeyReservationStatusQuery(reservationId ? [reservationId] : []);
    return data?.reservationDigitalKeyStatusResults?.[0]?.status === GxVirtualKeyCardInReservation.AlreadyIssued;
};

const keyResultById = createWeakMapSelector(
    (result: GxReservationDigitalKeyStatusResponse): Record<string, GxReservationDigitalKeyStatusResult> =>
        keyBy('reservationId', result.reservationDigitalKeyStatusResults)
);
export const useReservationModuleIsDigitalKeyStatus = (reservationId: string, groupId: string) => {
    const enterpriseId = useCurrentEnterpriseId();
    const reservationIds = useCommanderSelector((s) => getReservationIdsByGroupId(s, { groupId, enterpriseId }));
    const { data: statusByReservationId } = useDigitalKeyReservationStatusQuery(reservationIds, keyResultById);
    const result = statusByReservationId?.[reservationId];
    return result?.status === GxVirtualKeyCardInReservation.AlreadyIssued;
};
